import { shareURL } from '@telegram-apps/sdk-react'

export const useShareUrl = () => {
  const shareUrl = (params: { link: string; text?: string }) => {
    if (shareURL.isAvailable()) {
      shareURL(params.link, params.text)
      return
    }
    console.log('shareURL is not available.', params)
    return navigator.clipboard.writeText(params.link)
  }

  return {
    shareUrl,
  }
}
